import { Name } from './Name'
import { Person } from './Person'
import type { IUser } from '~/types/user/models'

export function User(o: IUser): IUser {
  const fn = '[cynqueModules/dataObjects/User.ts] User |'
  if (!o.person) {
    throw new Error(`${fn} User called with falsey user.person`)
  }

  const obj = { ...o }
  obj.person = Person(o.person)
  obj.avatar = { descr: obj.person.name.initials ?? '', type: 'user' }
  const nameDescr = Name(o.person.name).descr ?? 'No Name'
  obj.label = nameDescr
  console.debug(`${fn} returning`, obj)
  return obj
}
